// Auth API wrappers.
import { api } from "./client";
import type { Manifest, User } from "../stores/auth";

export type LoginResponse = {
  access_token: string | null;
  refresh_token: string | null;
  token_type: string;
  mfa_required: boolean;
  mfa_session: string | null;
  user: User | null;
};

export const authApi = {
  login: (username: string, password: string) =>
    api.post<LoginResponse>("/auth/login", { username, password }).then((r) => r.data),

  verifyMfa: (mfa_session: string, code: string) =>
    api.post<LoginResponse>("/auth/mfa/verify", { mfa_session, code }).then((r) => r.data),

  setupMfa: () =>
    api.post<{ secret: string; provisioning_uri: string }>("/auth/mfa/setup").then((r) => r.data),

  enableMfa: (code: string) =>
    api.post<void>("/auth/mfa/enable", { code }).then((r) => r.data),

  logout: (refresh_token: string) =>
    api.post<void>("/auth/logout", { refresh_token }).then((r) => r.data),

  me: () =>
    api.get<User>("/auth/me").then((r) => r.data),

  manifest: () =>
    api.get<Manifest>("/auth/me/permissions").then((r) => r.data),

  changePassword: (current_password: string, new_password: string) =>
    api.post<void>("/auth/password/change", { current_password, new_password }).then((r) => r.data),
};
